import { useEffect, useState } from "react";
import { Modal, Button, Input } from "antd";
import { blockUser } from "../../utils/users";
import { useAuth0 } from "@auth0/auth0-react";
import { useSnackbar } from "notistack";

const { TextArea } = Input;

const UserBlockModal = ({ id, showModal, onClose, onSuccess }) => {
  const { getIdTokenClaims } = useAuth0();
  const { enqueueSnackbar } = useSnackbar();
  const [submitting, setSubmitting] = useState(false);
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!showModal) {
      setReason("");
    }
  }, [showModal]);

  const handleBlockUser = () => {
    setSubmitting(true);

    (async () => {
      try {
        const token = await getIdTokenClaims();

        blockUser(token.__raw, id, reason)
          .then((res) => {
            if (!res.data.success) {
              console.log("Blocking user failed");
              enqueueSnackbar(res.data.message || "Failed to block user", {
                variant: "error",
              });
            } else {
              enqueueSnackbar(
                res.data.message || "User has been blocked successfully",
                {
                  variant: "success",
                }
              );
              onSuccess();
              onClose();
            }
          })
          .catch((err) => {
            console.error(err);
            enqueueSnackbar(
              "Something went wrong. Please contact support.",
              {
                variant: "error",
              }
            );
          })
          .finally(() => {
            setSubmitting(false);
          });
      } catch (e) {
        console.error(e);
        setSubmitting(false);
      }
    })();
  };

  const handleClose = () => {
    setSubmitting(false);
    setReason("");
    onClose();
  };

  return (
    <Modal
      title={[<div className={"text-2xl"}>Block User</div>]}
      centered
      open={showModal}
      destroyOnClose={true}
      footer={[
        <div className={"flex items-center justify-end gap-3"}>
          <Button
            key="cancel"
            className={"px-2 text-sm py-1.5 border border-gray-200 rounded-lg"}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            key="submit"
            className={"px-2 text-sm py-1.5"}
            onClick={() => {
              handleBlockUser();
            }}
            loading={submitting}
            danger
          >
            Block User
          </Button>
        </div>,
      ]}
      onCancel={handleClose}
    >
      <div className={"py-4 text-gray-500 text-sm border-b border-gray-300"}>
        <p className={"mb-4 text-gray-700"}>
          Are you sure you want to block this user? They will be logged out and
          unable to access the system.
        </p>
        <div>
          <label className={"block mb-2 text-gray-600 font-medium"}>
            Reason (Optional)
          </label>
          <TextArea
            placeholder="Enter reason for blocking this user..."
            rows={4}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            maxLength={500}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UserBlockModal;
